import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { FIELD_PRIMITIVE__string_hash_sha256 } from './FIELD_PRIMITIVE__string_hash_sha256';

//represents hash of image itself
export class FIELD_PRIMITIVE__string_hash_image_uploaded extends FIELD_PRIMITIVE__string_hash_sha256 {
  /*
   * STATIC FIELDS
   */

  static _class_name_static = ENUM__dto_class_name.GRAPH_FIELD_PRIMITIVE_STRING_HASH_IMAGE_UPLOADED;

  constructor() {
    super();
  }
}
